// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"8980274a","69":"f0c70619","103":"16b49ab2","136":"0915fcfc","153":"8fc0b9ee","453":"ba36cf83","457":"5bdcacd3","559":"0db2d2e5"}[chunkId] + ".chunk.js";
};